import React from "react"
import {connect} from "react-redux"
import {Button, ButtonGroup} from "react-bootstrap"
import {
	addWorker,
	removeWorker,
	addTechnicalWorker,
	removeTechnicalWorker,
	addSetWorker,
	removeSetWorker,
	addPackingWorker,
	removePackingWorker,
	plusOriginFloor,
	minusOriginFloor,
	plusDestinationFloor,
	minusDestinationFloor,
	addExpensive,
	removeExpensive,
} from "../../actions/actionCreators"
import {withRouter} from "react-router-dom"
import {
	CHANGE_DEST_FLOOR,
	CHANGE_ORIGIN_FLOOR,
} from "../../actions/actionsTypes"
import {actions} from "react-bootstrap-sweetalert/dist/styles/SweetAlertStyles"

const mapStateToProps = (state) => ({...state.order})
const mapDispatchToProps = (dispatch) => ({
	changeOriginFloor: (e) => {
		dispatch({type: CHANGE_ORIGIN_FLOOR, floor: e.target.value})
	},
	changeDestFloor: (e) => {
		dispatch({type: CHANGE_DEST_FLOOR, floor: e.target.value})
	},
})
const Plus = () => {
	return (
		<svg
			width='18px'
			height='18px'
			viewBox='0 0 24 24'
			fill='none'
			stroke='currentColor'
			stroke-width='2'
			stroke-linecap='round'
			stroke-linejoin='round'
			className='feather feather-plus'>
			<line x1='12' y1='5' x2='12' y2='19' />
			<line x1='5' y1='12' x2='19' y2='12' />
		</svg>
	)
}

const Minus = () => {
	return (
		<svg
			width='18px'
			height='18px'
			viewBox='0 0 24 24'
			fill='none'
			stroke='currentColor'
			stroke-width='2'
			stroke-linecap='round'
			stroke-linejoin='round'
			className='feather feather-plus'>
			<line x1='5' y1='12' x2='19' y2='12' />
		</svg>
	)
}

const initQuantityButtons = (props) => {
	const checkOut = () => {
		let item = null
		switch (props.eventKey) {
			case "worker":
				return {
					number: props.order.barbar_worker,
					add: addWorker,
					remove: removeWorker,
				}
			case "tech_service":
				return {
					number: props.order.tech_worker,
					add: addTechnicalWorker,
					remove: removeTechnicalWorker,
				}
			case "layout_service":
				return {
					number: props.order.layout_worker,
					add: addSetWorker,
					remove: removeSetWorker,
				}
			case "packing_service":
				return {
					number: props.order.chideman_worker,
					add: addPackingWorker,
					remove: removePackingWorker,
				}

			case "originFloor":
				return {
					number: props.order.origin_floor,
					add: plusOriginFloor,
					remove: minusOriginFloor,
					changeAction: props.changeOriginFloor,
				}

			case "destinationFloor":
				return {
					number: props.order.destination_floor,
					add: plusDestinationFloor,
					remove: minusDestinationFloor,
					changeAction: props.changeDestFloor,
				}
			case "refrigrator":
				item = props.order.vasayeleHazinedar.find((item) => item.id === 1)
				return {
					number: item ? item.count : 0,
					add: () => addExpensive(1),
					remove: () => removeExpensive(1),
				}

			case "dresser":
				item = props.order.vasayeleHazinedar.find((item) => item.id === 5)
				return {
					number: item ? item.count : 0,
					add: () => addExpensive(5),
					remove: () => removeExpensive(5),
				}

			case "table":
				item = props.order.vasayeleHazinedar.find((item) => item.id === 10)
				return {
					number: item ? item.count : 0,
					add: () => addExpensive(10),
					remove: () => removeExpensive(10),
				}

			case "heavy_safe":
				item = props.order.vasayeleHazinedar.find((item) => item.id === 11)
				return {
					number: item ? item.count : 0,
					add: () => addExpensive(11),
					remove: () => removeExpensive(11),
				}

			case "piano":
				item = props.order.vasayeleHazinedar.find((item) => item.id === 4)
				return {
					number: item ? item.count : 0,
					add: () => addExpensive(4),
					remove: () => removeExpensive(4),
				}

			case "treadmill":
				item = props.order.vasayeleHazinedar.find((item) => item.id === 6)
				return {
					number: item ? item.count : 0,
					add: () => addExpensive(6),
					remove: () => removeExpensive(6),
				}

			case "safe":
				item = props.order.vasayeleHazinedar.find((item) => item.id === 8)
				return {
					number: item ? item.count : 0,
					add: () => addExpensive(8),
					remove: () => removeExpensive(8),
				}

			default:
				return {
					number: 0,
					add: undefined,
					remove: undefined,
				}
		}
	}

	return (
		<ButtonGroup className='quantity'>
			<Button onClick={checkOut().remove} variant='light'>
				<Minus />
			</Button>
			<h3>
				<input
					style={{textAlign: "center"}}
					type='number'
					onChange={checkOut().changeAction}
					value={checkOut().number ?? ""}
				/>
			</h3>
			<Button onClick={checkOut().add} variant='light'>
				<Plus />
			</Button>
		</ButtonGroup>
	)
}

const QuantityButtons = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(initQuantityButtons),
)

export {Plus, Minus, QuantityButtons}
